<template>
    <v-card class="mb-3" @click="$emit('open', stop)">
        <v-card-text class="d-flex align-center">
            <v-avatar :color="statusColor" size="34" class="mr-3">
                <span class="white--text">{{ stop.seq }}</span>
            </v-avatar>
            <div class="flex-grow-1">
                <div class="subtitle-1 black--text">{{ stop.custName || '(ไม่ระบุชื่อ)' }}</div>
                <div class="body-2 grey--text text--darken-1">{{ district }}</div>
                <div class="body-2">
                    <span class="grey--text text--darken-1">นัด {{ stop.promisedTime || '-' }}</span>
                    <span v-if="actualText" class="ml-2 grey--text text--darken-3">
                        {{ actualText }}
                    </span>
                    <span v-else-if="stop.etaClock" class="ml-2" :class="etaClass">
                        ถึงราว {{ stop.etaClock }}
                    </span>
                </div>
            </div>
            <v-chip small :color="statusColor" dark>{{ statusLabel }}</v-chip>
        </v-card-text>
    </v-card>
</template>
<script>
import D from '@/components/driverDay'
const LABELS = {
    pending: 'ยังไม่ออก', enroute: 'กำลังไป', arrived: 'ถึงแล้ว',
    installing: 'กำลังติดตั้ง', done: 'เสร็จแล้ว', failed: 'ส่งไม่สำเร็จ'
}
const COLORS = {
    pending: 'grey', enroute: 'blue', arrived: 'orange accent-4',
    installing: 'deep-purple', done: 'green', failed: 'red'
}
// The statuses that mean the driver is standing at, or has left, the customer.
const REACHED = { arrived: true, installing: true, done: true, failed: true }
export default {
    props: { stop: { type: Object, required: true } },
    computed: {
        // A stop the customer has signed for but the driver has not closed
        // (ปิดงาน page 3 still to do) says so on the day list, where a driver
        // scanning for unfinished work would otherwise read กำลังติดตั้ง.
        statusLabel () {
            if (D.awaitingClose(this.stop)) return 'รอปิดงาน'
            return LABELS[this.stop.status] || LABELS.pending
        },
        statusColor () { return COLORS[this.stop.status] || COLORS.pending },
        // A stop the driver has reached shows what HAPPENED, and never a
        // forecast beside it. 'ถึงราว 10:16' next to a เสร็จแล้ว chip is not a
        // stale estimate the reader can discount -- it is a prediction of an
        // event that is already over, sitting where the real time should be.
        // driverDay only fills these in for a stop whose status says it was
        // reached, so status and times cannot disagree.
        actualText () {
            if (!REACHED[this.stop.status]) return ''
            const arrived = this.stop.actualArrive
            if (this.stop.actualFinish) {
                const word = this.stop.status === 'failed' ? ' · ปิดงาน ' : ' · เสร็จ '
                return 'ถึง ' + (arrived || '-') + word + this.stop.actualFinish
            }
            return arrived ? 'ถึงจริง ' + arrived : ''
        },
        // An ETA carried from the promised time rather than measured is the
        // weaker number, and is shown as such rather than passed off as an
        // estimate the app stands behind.
        etaClass () { return this.stop.etaSource === 'promised' ? 'grey--text' : 'orange--text text--darken-3' },
        district () {
            const m = /อ\.[^\s]+|เขต[^\s]+/.exec(this.stop.custAddress || '')
            return m ? m[0] : (this.stop.custAddress || '').slice(0, 40)
        }
    }
}
</script>
